import { singleton } from "tsyringe";
import developmentConfig from "./development.json";
import preprodConfig from "./preprod.json";
import stagingConfig from "./staging.json";
import productionConfig from "./production.json";

@singleton()
export default class ApplicationConfig {
	private config: typeof developmentConfig = developmentConfig;
	public constructor() {
		this.setConfig();
	}

	public get() {
		const apiUrlOverride = process.env["REACT_APP_API_URL"];
		if (apiUrlOverride !== undefined) {
			return { ...this.config, api: { ...this.config.api, rootUrl: this.localApiUrl(apiUrlOverride) } };
		}
		return this.config;
	}

	private localApiUrl(apiUrl: string) {
		if (!apiUrl) return apiUrl;
		// Both local hostnames must share the browser cookie host.
		if (process.env.NODE_ENV === "development" && ["localhost", "127.0.0.1"].includes(window.location.hostname)) {
			const url = new URL(apiUrl);
			if (["localhost", "127.0.0.1"].includes(url.hostname)) {
				url.hostname = window.location.hostname;
				return url.href.replace(/\/$/, "");
			}
		}
		return apiUrl;
	}

	private setConfig() {
		switch (process.env["REACT_APP_ENV"]) {
			case "staging":
				this.config = stagingConfig;
				break;
			case "preprod":
				this.config = preprodConfig;
				break;
			case "production":
				this.config = productionConfig;
				break;
		}
	}
}
